/* eslint-disable react/react-in-jsx-scope */
//import logo from './logo.svg';
//import './App.css';
import {
  BrowserRouter,
  HashRouter,
  Route,
  Routes,
  useParams,
} from "react-router-dom";
import classNames from "classnames";
import { ConnectedRouter } from "connected-react-router";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { createBrowserHistory } from "history";
import { Suspense } from "react";
import { useTranslation } from "react-i18next";
import SigninScreen from "./screens/SigninScreen";
import RegisterScreen from "./screens/RegisterScreen";
import { signout } from "./actions/userActions";
import UploadVideoScreen from "./screens/mvman/UploadVideoScreen";
import ProfileScreen from "./screens/ProfileScreen";
import PrivateRoute from "./components/PrivateRoutes/PrivateRoute";
import MVManRoute from "./components/PrivateRoutes/MVManRoute";
import RecordListScreen from "./screens/RecordListScreen";
import FinanceDashboardScreen from "./screens/FinanceDashboardScreen";
import YearlyReportScreen from "./screens/YearlyReportScreen";
import RecordSearchScreen from "./screens/RecordSearchScreen";
import ListCategories from "./components/ListCategories";
import CategoryList from "./components/CategoryList";
import RecordEditScreen from "./screens/RecordEditScreen";
import WeixinmpPage from "./views/weixin/WeixinmpPage";
import Home from "./screens/FinanceHomeScreen";
import styles from "assets/jss/vivoleo-react-kit/views/components.js";
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import FMParallax from "components/Parallax/FMParallax.js";
// sections for this page
import HeaderLinks from "components/Header/HeaderLinks.js";
import CategoryEditScreen from "./screens/CategoryEditScreen.js";
import AddCategoryScreen from "./screens/AddCategoryScreen.js";
import EditTaxScreen from "./screens/EditTaxScreen.js";
import TaxrateDetailScreen from "./screens/TaxrateDetailScreen.js";
import AddRemoveCat from "components/AddRemoveCat.js";
import GenerateReportScreen from "screens/financereport/GenerateReportScreen";
import RptItemScreen from "screens/financereport/RptItemScreen";
import AllRptItemScreen from "screens/financereport/AllRptItemScreen";
import { history } from "./store";

const useStyles = makeStyles(styles);

function App(props) {
  //var hist = createBrowserHistory({ basename: process.env.PUBLIC_URL });
  //var hist = createBrowserHistory();
  const classes = useStyles();
  const { ...rest } = props;
  const { t } = useTranslation();
  //const { history } = useParams();
  //const hist = props.history;
  return (
    <HashRouter history={history} basename="/">
      <Header
        brand="VIVOLEO MV"
        rightLinks={<HeaderLinks />}
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 400,
          color: "#65fbfb",
        }}
        {...rest}
      />
      <FMParallax homePageFilter>
        <div className={classes.container}>
          <GridContainer>
            <GridItem>
              <div className={classes.brand}></div>
            </GridItem>
          </GridContainer>
        </div>
      </FMParallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <Routes>
            <Route path="/" element={<Home />}></Route>
            <Route path="/WeixinmpPage" element={<WeixinmpPage />}></Route>
            <Route path="/signin" element={<SigninScreen />}></Route>
            <Route path="/register" element={<RegisterScreen />}></Route>
          </Routes>
          <MVManRoute
            path="/uploadvideo"
            element={<UploadVideoScreen />}
          ></MVManRoute>
          <PrivateRoute
            path="/profile"
            element={<ProfileScreen />}
          ></PrivateRoute>
          <MVManRoute
            path="/recordlist"
            element={<RecordListScreen />}
          ></MVManRoute>
          <MVManRoute
            path="/financedashboard"
            element={<FinanceDashboardScreen />}
          ></MVManRoute>
          <MVManRoute
            path="/showyearlyreport"
            element={<YearlyReportScreen />}
          ></MVManRoute>
          <MVManRoute
            path="/searchrecord/category/:category"
            element={<RecordSearchScreen />}
          ></MVManRoute>
          <MVManRoute
            path="/searchrecord"
            element={<RecordSearchScreen />}
          ></MVManRoute>
          <MVManRoute
            path="/records/:id/edit"
            element={<RecordEditScreen />}
          ></MVManRoute>
          <MVManRoute
            path="/listcategory"
            element={<ListCategories />}
          ></MVManRoute>
          <MVManRoute
            path="/categorylist"
            element={<CategoryList />}
          ></MVManRoute>
          <MVManRoute
            path="/catrecords/:id"
            element={<CategoryEditScreen />}
          ></MVManRoute>
          <MVManRoute
            path="/addcategory"
            element={<AddCategoryScreen />}
          ></MVManRoute>
          <MVManRoute path="/edittax" element={<EditTaxScreen />}></MVManRoute>
          <MVManRoute
            path="/taxrate/:id"
            element={<TaxrateDetailScreen />}
          ></MVManRoute>
          <MVManRoute
            path="/edittaxcategory/:id"
            element={<AddRemoveCat />}
          ></MVManRoute>
          <MVManRoute
            path="/generatereport"
            element={<GenerateReportScreen />}
          ></MVManRoute>
          <MVManRoute
            path="/rptitem/:itemname"
            element={<RptItemScreen />}
          ></MVManRoute>
          <MVManRoute
            path="/listreportitems"
            element={<AllRptItemScreen />}
          ></MVManRoute>
        </div>
      </div>
      <div className={classes.sectionSpace}></div>
      <Footer />
    </HashRouter>
  );
}
//export default App;
export default function WrappedApp() {
  return (
    <Suspense fallback="...is loading">
      <App />
    </Suspense>
  );
}
